// Landing-page-only palette. Scoped here (not utility/colors.js) since the
// brighter logoBlue and the grey page canvas are deliberate landing-page
// choices, not app-wide ones.
//
// Design system: `background` (F5F5F5, matches the prior Framer site) is the
// page canvas everywhere. `surface` (white) is used for anything that should
// read as a card/panel floating on that canvas — feature cards, testimonial
// cards, the get-the-app card, badges. Since white-on-F5F5F5 is a very subtle
// color difference, surfaces also get `cardShadow` for definition.
export const landingColors = {
  primary: "#009EDD", // logoBlue
  accent: "#046287", // primaryBlue — secondary accents/hover states
  background: "#F5F5F5",
  surface: "#FFFFFF",
  screenshotSurface: "#EBEBEB", // FeatureGrid card background
  textPrimary: "#1f2937",
  textSecondary: "#374151",
  border: "#DADADA",
  borderStrong: "#A7A7A7",
  disabled: "#879094",
  error: "#C0392B",
  cardShadow: "0 1px 2px rgba(15,23,42,0.04), 0 4px 16px rgba(15,23,42,0.06)",
};
